import { render, staticRenderFns } from "./CustomizationPage.vue?vue&type=template&id=27f948da&scoped=true"
import script from "./CustomizationPage.vue?vue&type=script&lang=js"
export * from "./CustomizationPage.vue?vue&type=script&lang=js"
import style0 from "./CustomizationPage.vue?vue&type=style&index=0&id=27f948da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f948da",
  null
  
)

export default component.exports